<template>
  <div>
    <el-card>
      <div slot="header">
        <span>标题</span>
      </div>

      <div class="row-no-full">
        <div class="col" style="width: 100%;">
          <el-form label-position="right" label-width="100px" :model="item" ref='form' :rules="rules">


            <el-form-item label="分类" prop="category_id" required>
              <category  :category_id.sync="item.category_id" :pid="getEnv('category_id')"></category>
            </el-form-item>


            <el-form-item label="商品名称" prop="title" required>
              <el-input v-model="item.title" size="small" placeholder="商品名称"></el-input>
            </el-form-item>


            <el-form-item label="商品图片" prop="img" required>



              <upload @success='img_upload' ></upload>

              <div v-if="item.img">

                <el-image :src='getImgPrefix()+item.img'></el-image>
              </div>

            </el-form-item>


            <el-form-item label="图册" prop="title">

              <img-list :UploadProperty="{resize:'500'}" :list.sync="item.img_list"></img-list>

              <!-- <upload @success='img_list_upload' :resize="500" :more="true"></upload>

              <div v-if="item.img_list.length>0" class="row-no-full">


                <div v-for='(v,i) in item.img_list' :key='"img"+i' style='margin-right: 10px;'>

                  <el-image :src='getImgPrefix()+v'></el-image>

                </div>




              </div> -->

            </el-form-item>


            <el-form-item label="描述" prop="title">
              <el-input v-model="item.desc" size="small" placeholder="描述" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
            </el-form-item>


            <el-form-item label="状态" prop="title">
              <el-switch v-model="item.status"  :active-value="1" :inactive-value="2" active-color="#13ce66">
              </el-switch>
            </el-form-item>


<!--            <el-form-item label="推荐到首页" prop="title">-->
<!--              <el-switch v-model="item.is_recommend"  :active-value="1" :inactive-value="2" active-color="#13ce66">-->
<!--              </el-switch>-->
<!--            </el-form-item>-->


            <el-form-item>
              <el-button type="primary" size="small" @click='submit()'>提交</el-button>
            </el-form-item>

          </el-form>
        </div>
      </div>


    </el-card>
  </div>
</template>

<script>
  import Category from '../common/Category.vue'
  import Upload from '../common/Upload.vue'
  import ImgList from '../common/ImgList.vue'
  export default {
    name: "RuleEdit",
    data() {
      return {
        item: {
          title: '',
          img: '',
          img_list: [],
          category_id: "",
          desc: '',
          is_recommend: 2,
          status: 1,
          id:''
        },
        rules: {
          username: [{
            required: true,
            message: '用户名不能为空',
            trigger: 'blur'
          }],
        },

      }
    },
    methods: {

      submit() {


        this.$refs['form'].validate((valid) => {
          if (valid) {

            this.msgBoxAjaxWithMessage('提示','确定提交吗？','/admin/goods/update',this.item).then((re)=>{

                this.$router.go(-1);

            })


          } else {
            console.log('error submit!!');
            return false;
          }
        });


      },
      img_upload(e) {

        this.item.img = e;

      },
      img_list_upload(e) {


        for (let i in e) {

          this.item.img_list.push(e[i]);

        }

      },
      detail(){


        if(!this.$route.query.id) return;

        this.httpPost({
          url:'/admin/goods/detail',
          data:{id:this.$route.query.id},
          loading:true,
        }).then((re)=>{

          this.setItem(this.item,re.data);

        })


      }


    },
    created() {

      this.detail();

    },
    computed: {

    },
    components: {
      Category,
      Upload,
      ImgList
    }

  }
</script>

<style scoped>
  form>.el-form-item {

    max-width: 600px;

  }
</style>



// WEBPACK FOOTER //
// src/components/goods/GoodsEdit.vue